import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import axios from 'axios';
import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// form
import { useFormik, Form, FormikProvider } from 'formik';
// @mui
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  styled,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { updateUser, removeUser } from '../../../utils/redux/userSlice';

// ----------------------------------------------------------------------

const CssTextField = styled(TextField)({
  '& .MuiOutlinedInput-root ': {
    borderRadius: 2,
    boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.15)',
    fontFamily: 'Roboto',
  },
});

const CssButton = styled(LoadingButton)({
  '&.MuiButtonBase-root': {
    borderRadius: '3px',
    boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.15)',
    fontFamily: 'Roboto',
    '&:hover': {
      boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.15)',
    },
  },
});

export default function LoginForm() {
  const apiURL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const uninterceptedAxiosInstance = axios.create();
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

  const whereToNavigate = (role) => {
    
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      admin: false,
    }, 
    validationSchema: LoginSchema,
    onSubmit: async () => {
      try {
        let loginURL = `${apiURL}/auth/member/login`;
        if (values.admin) {
          loginURL = `${apiURL}/auth/admin/login`;
        }
        const res = await uninterceptedAxiosInstance.post(loginURL, values);
        if (res.data.isError) {
          console.log(res.data.message);
          toast.error(res.data.message);
          dispatch(removeUser());
        } else {
          localStorage.setItem('accessToken', res.data.data.token);
          localStorage.setItem('profile', JSON.stringify(res.data.data));
          dispatch(updateUser(res.data.data));
          navigate('/dashboard/app', { replace: true });
        }
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        dispatch(removeUser());
      }
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3} mb={4}>
          <CssTextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <CssTextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="start" sx={{ my: 2, width: '100%' }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('admin')} checked={values.admin} />}
            label="Login as Admin"
          />

          {/* <Typography
            sx={{ fontSize: '18px', cursor: 'pointer', color:"#07ADBB" }}
            onClick={() => setForgotPass(true)}
          >
            Forgot password?
          </Typography> */}
        </Stack>

        <CssButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Log In
        </CssButton>
      </Form>
    </FormikProvider>
  );
}
